
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import UnassignedJobsList from './UnassignedJobsList.vue'
import DraftJobsList from './DraftJobsList.vue'

@Component({
  components: { UnassignedJobsList, DraftJobsList }
})
export default class UnassignedJobsCard extends Vue {

  get unassignedList () {
    return this.$refs.unassignedList as UnassignedJobsList
  }

  get draftList () {
    return this.$refs.draftList as DraftJobsList
  }

  public refresh () {
    this.draftList.updateResults()
    this.unassignedList.updateResults()
  }
}
